/* eslint-disable tailwindcss/no-arbitrary-value */
import React from 'react';
import { Typography } from '@one-thd/sui-atomic-components';
import { RewardsAndOffersContext, RewardsHubContext } from '../../../contexts';
import { links, pbSpendSummary, tierBadges } from '../../../constants';
import { assets } from '../../../images/AssetPaths';
import { getImageURL, isAdmin } from '../../../utils/GeneralUtil';
import { rhBanner } from '../../../constants/RewardsHub';
import { toStartCase } from '../../Utils';
import { SpendSummaryTooltip } from '../../shared/tooltips/SpendSummaryTooltip';
import { useIsMobile, useIsTablet } from '../../../hooks/use-responsive';
import * as variables from '../../../styles/_exports.module.scss';
export var ToolTipMessage = function () {
    return (React.createElement("div", { className: "toolTipMessage" },
        React.createElement("p", null,
            pbSpendSummary.spendIncludesLoyalty,
            "\u00A0"),
        React.createElement("br", null),
        React.createElement("p", null, pbSpendSummary.savingIncludes),
        React.createElement("br", null),
        React.createElement("p", null,
            pbSpendSummary.fullDetails,
            "\u00A0",
            React.createElement("a", { className: "u__default-link", target: "_blank", href: links.faqTermsAndConditions, rel: "noreferrer" }, links.termsAndConditionsTitle))));
};
var styleBadge = {
    MEMBER: { backgroundColor: variables.brand },
    ELITE: { backgroundColor: variables.darkbrandtierbadge },
    VIP: { backgroundColor: variables.primarytierbadge },
};
var styleBanner = {
    MEMBER: { backgroundColor: variables.brand, marginLeft: '-16px' },
    ELITE: { backgroundColor: variables.darkbrandtierbadge, marginLeft: '-16px' },
    VIP: { backgroundColor: variables.primarytierbadge, marginLeft: '-16px' },
};
export var RenderTierBadge = function () {
    var membershipLevel = React.useContext(RewardsHubContext).membershipLevel;
    var membership = tierBadges[membershipLevel];
    return (React.createElement("div", { className: "sui-flex" },
        React.createElement("img", { src: membership === null || membership === void 0 ? void 0 : membership.icon, className: "sui-transform sui-rotate-180", style: {
                marginRight: '-1px',
                height: '49px',
            }, alt: "x-badge", height: "auto", width: "auto" }),
        React.createElement("span", { className: "sui-flex sui-items-center sui-justify-end sui-pr-6 sui-text-4xl sui-w-44", style: styleBadge[membership === null || membership === void 0 ? void 0 : membership.label] },
            React.createElement(Typography, { variant: "h3", weight: "display", color: "inverse" }, membership === null || membership === void 0 ? void 0 : membership.label))));
};
var RenderTierBanner = function () {
    var membershipLevel = React.useContext(RewardsHubContext).membershipLevel;
    var membership = tierBadges[membershipLevel];
    return (React.createElement("div", { className: "sui-flex sui-w-full sui-h-14" },
        React.createElement("span", { className: "sui-flex sui-items-center sui-justify-start sui-pr-6 sui-text-4xl sui-w-full", style: styleBanner[membership === null || membership === void 0 ? void 0 : membership.label] },
            React.createElement("img", { className: "sui-mr-2 sui-ml-6", src: assets.proXtraLogoText, alt: "logo-text", height: "21", width: "85" }),
            React.createElement(Typography, { variant: "h2", weight: "display", color: "inverse" }, membership === null || membership === void 0 ? void 0 : membership.label)),
        React.createElement("img", { src: membership === null || membership === void 0 ? void 0 : membership.icon, style: { marginLeft: '-1px', height: '56px' }, className: "sui-transform", alt: "x-badge", height: "auto", width: "auto" })));
};
export var BannerText = function (_a) {
    var isMobile = _a.isMobile;
    var rewardsAndOffers = React.useContext(RewardsAndOffersContext).rewardsAndOffers;
    var proTiers = (rewardsAndOffers || {}).proTiers;
    return (proTiers === null || proTiers === void 0 ? void 0 : proTiers.currentTierEndDate) ? (React.createElement("div", { className: "".concat(isMobile ? 'sui-mb-6' : '') },
        React.createElement(Typography, null,
            rhBanner.deadlineText,
            " ",
            React.createElement("b", null, proTiers === null || proTiers === void 0 ? void 0 : proTiers.currentTierEndDate)))) : (React.createElement(React.Fragment, null));
};
export var HeaderInfoDT = function () {
    var _a, _b, _c, _d, _e, _f;
    var _g = React.useContext(RewardsAndOffersContext), rewardsAndOffers = _g.rewardsAndOffers, isChildAccount = _g.isChildAccount;
    var isTablet = useIsTablet().isTablet;
    if (!(rewardsAndOffers === null || rewardsAndOffers === void 0 ? void 0 : rewardsAndOffers.userProfile))
        return React.createElement(React.Fragment, null);
    var first = (_b = (_a = rewardsAndOffers === null || rewardsAndOffers === void 0 ? void 0 : rewardsAndOffers.userProfile) === null || _a === void 0 ? void 0 : _a.name) === null || _b === void 0 ? void 0 : _b.firstName;
    var last = (_d = (_c = rewardsAndOffers === null || rewardsAndOffers === void 0 ? void 0 : rewardsAndOffers.userProfile) === null || _c === void 0 ? void 0 : _c.name) === null || _d === void 0 ? void 0 : _d.lastName;
    var firstName = first && "".concat(first[0].toUpperCase()).concat(first.slice(1).toLowerCase());
    var lastName = last && "".concat(last[0].toUpperCase()).concat(last.slice(1).toLowerCase());
    var savings = Number((_e = rewardsAndOffers === null || rewardsAndOffers === void 0 ? void 0 : rewardsAndOffers.proXtraSpend) === null || _e === void 0 ? void 0 : _e.totalCurrentYearSavings.replace(/,/g, ''));
    var savingsText = isChildAccount
        ? 'Total Company Savings'
        : 'Total Savings';
    var spendText = isChildAccount
        ? 'Total Company Loyalty Spend'
        : 'Total Loyalty Spend';
    var RenderSpendAndSavings = function () {
        var _a, _b;
        return (React.createElement("div", { className: "sui-absolute sui-right-6", style: {
                minWidth: '376px',
                right: '24px',
                top: '98px',
            } },
            React.createElement("div", { className: "sui-flex sui-justify-end" },
                React.createElement("div", { className: "sui-flex sui-flex-col" },
                    React.createElement(Typography, { variant: "h3", weight: "display", align: "right" },
                        "$",
                        ((_a = rewardsAndOffers === null || rewardsAndOffers === void 0 ? void 0 : rewardsAndOffers.proXtraSpend) === null || _a === void 0 ? void 0 : _a.totalCurrentYearSpend) || 0),
                    React.createElement("div", { className: "sui-pt-3 sui-flex sui-justify-end" },
                        React.createElement(Typography, { variant: "body-base", align: "right", lineClamp: "1" }, spendText),
                        React.createElement(SpendSummaryTooltip, null))),
                savings > 0 && (React.createElement("div", { className: "sui-pl-2 ".concat(isTablet ? "" : "sui-pl-6") },
                    React.createElement("div", { className: "sui-flex sui-flex-col sui-pl-6" },
                        React.createElement(Typography, { variant: "h3", weight: "display", color: "success", align: "right" },
                            "$",
                            ((_b = rewardsAndOffers === null || rewardsAndOffers === void 0 ? void 0 : rewardsAndOffers.proXtraSpend) === null || _b === void 0 ? void 0 : _b.totalCurrentYearSavings) || 0),
                        React.createElement("div", { className: "sui-pt-3" },
                            React.createElement(Typography, { variant: "body-base", align: "right", lineClamp: "1" }, savingsText))))))));
    };
    if (rewardsAndOffers) {
        return (React.createElement("div", { className: "sui-pt-2" },
            React.createElement("div", { className: "sui-px-6 sui-pt-6" },
                React.createElement("div", { className: "sui-truncate", style: {
                        marginRight: '375px',
                    } },
                    !isChildAccount && (React.createElement(Typography, { variant: "h3", weight: "display", truncate: true },
                        firstName,
                        "\u00A0",
                        lastName)),
                    React.createElement("div", { className: isChildAccount ? '' : 'sui-pt-3' },
                        React.createElement(Typography, { variant: isChildAccount ? 'h3' : 'body-base', weight: isChildAccount ? 'display' : 'regular', truncate: true }, toStartCase((_f = rewardsAndOffers === null || rewardsAndOffers === void 0 ? void 0 : rewardsAndOffers.customerInfo) === null || _f === void 0 ? void 0 : _f.companyName)))),
                isAdmin() && React.createElement(RenderSpendAndSavings, null))));
    }
    return React.createElement(React.Fragment, null);
};
var BannerMW = function () {
    var isConsumerApp = useIsMobile().isConsumerApp;
    if (isConsumerApp) {
        return (React.createElement("div", { className: "sui-mb-8" },
            React.createElement(RenderTierBanner, null)));
    }
    return React.createElement(React.Fragment, null);
};
var BannerDTW = function () {
    var BannerLogo = function () { return (React.createElement("div", { className: "sui-py-2" },
        React.createElement("img", { src: getImageURL('logo-Pro-Xtra-grey.svg'), alt: "logo", height: "32px", width: "130px" }))); };
    return (React.createElement("div", { className: "sui-pb-4" },
        React.createElement("div", { className: "sui-pb-10" },
            React.createElement("div", { className: "sui-pl-6 sui-py-2 sui-bg-pro-sawdust sui-flex sui-flex-row sui-justify-between" },
                React.createElement(BannerLogo, null),
                React.createElement(RenderTierBadge, null)),
            React.createElement(HeaderInfoDT, null))));
};
export var RewardsHubBanner = function (_a) {
    var isMobile = _a.isMobile;
    return isMobile ? React.createElement(BannerMW, null) : React.createElement(BannerDTW, null);
};
